export async function getFreshAccess({ minTtlSec = 30 } = {}) {
    const readAccess = () => {
        try { return window.localStorage.getItem('auth_access') || '' } catch { return '' }
    }
    const parseExp = (jwt) => {
        try {
            const [, payloadB64] = jwt.split('.')
            if (!payloadB64) return 0
            const json = JSON.parse(atob(payloadB64.replace(/-/g, '+').replace(/_/g, '/')))
            return Number(json?.exp || 0)
        } catch { return 0 }
    }

    let access = readAccess()
    const now = Math.floor(Date.now() / 1000)
    const exp = parseExp(access)

    const needsRefresh = !access || !exp || exp - now <= minTtlSec
    if (needsRefresh) {
        try {
            const { useAuthStore } = await import('@/stores/auth.js')
            const auth = useAuthStore()
            await auth.refreshAccess() // должен обновить localStorage
            access = readAccess()
        } catch (_) {
            // провал рефреша — пусть вызывающий обработает (например, не подключаться и предложить логин)
        }
    }
    return access
}